module.exports = __webpack_public_path__ + "img/bg-2.89072946.jpg";